// extracted by mini-css-extract-plugin
module.exports = {"container":"Mg_Y43tU","indicator":"_FnGkkuV"};